export default "__VITE_ASSET__ceb2d317__"